import script from "./OrganisationMembership.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganisationMembership.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__